import { Find } from 'icon'

import BaseBtn from './BaseBtn'

const FindBtn = (props) => {
  const { disabled, onClick, loading, tag } = props

  return (
    <BaseBtn
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      tag={tag}
      icon={<Find color="grey" size={0.8} />}
      color={'grey'}
      bg_color={'white'}
    />
  )
}

export default FindBtn
